import React from 'react';
import classes from './AdminMovieCard.scss';
import MovieCard from '../../../../components/MovieCard';
import MovieThumbnail from '../../../../components/MovieThumbnail';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';

class Overlay extends React.Component {
  static propTypes = {
    id: PropTypes.string.isRequired,
    onDelete: PropTypes.func
  };

  constructor (props) {
    super(props);
    this.handleDelete = this.handleDelete.bind(this);
  }

  handleDelete () {
    this.props.onDelete(this.props.id);
  }

  render () {
    return (
      <div className={classes['overlay']}>
        <div className={classes['buttons']}>
          <Link to={`/admin/movies/${this.props.id}`}>Edit</Link>
          <a onClick={this.handleDelete}>Delete</a>
        </div>
      </div>
    );
  }
}

const OverlayNew = ({ id }) => (
  <div className={classes['overlay-new']}>
    <Link to={`/admin/movies/${id}`}>New Movie</Link>
  </div>
);

OverlayNew.propTypes = {
  id: PropTypes.string.isRequired
};

export default class AdminMovieCard extends React.Component {
  static propTypes = {
    onDelete: PropTypes.func.isRequired,
    movie: PropTypes.object.isRequired,
    image: PropTypes.string.isRequired,
    lang: PropTypes.string.isRequired,
    isNewMovie: PropTypes.bool,
    stock: PropTypes.bool.isRequired
  };

  constructor (props) {
    super(props);
    this.handleDelete = this.handleDelete.bind(this);
  }

  handleDelete (movieId) {
    this.props.onDelete(movieId);
  }

  render () {
    const {movie, lang, isNewMovie, image, stock} = this.props;
    const thumbnail = <MovieThumbnail image={image} stock={stock} />;

    return (
      <MovieCard movie={movie} lang={lang} className="nogrow">
        {isNewMovie
          ? React.cloneElement(thumbnail, {}, <OverlayNew id={movie.id} />)
          : React.cloneElement(thumbnail, {}, <Overlay id={movie.id} onDelete={this.handleDelete} />)
        }
      </MovieCard>
    );
  }
};
